import {differenceInDays} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {parseDate} from 'shared/web';

export function isSoldIn30Days(car: {is_sold: boolean | null; last_occurrence: string | null}) {
  if (isNil(car.last_occurrence) || isEmpty(car.last_occurrence)) {
    return false;
  }
  return !!car.is_sold && differenceInDays(new Date(), parseDate(car.last_occurrence)) <= 30;
}
